import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ResultsContainer = styled.div``;

export const SearchHitLink = styled(Link)`
  margin-right: ${({ theme }) => theme.spacing.sm};
`;

export const ResultGroupTitle = styled.h3`
  margin-top: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
`;

export const NoResultsTitle = styled.h2`
  text-align: center;
  color: ${({ theme }) => theme.colors.N60};
  margin: ${({ theme }) => theme.spacing.md} 0;
`;
